import React, { Component } from 'react';
import $ from 'jquery';

import CourseLayout from './../courselayout';


import { getCoursesbyUser } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

class ListCourse extends Component {

    constructor(props) {
        super(props);
        this.state = {
          auth_data: JSON.parse(localStorage.getItem("user_data")),
          list: []
        };
    }

    componentDidMount() {
            this.getCourses();
    }

    getCourses = (e) =>{

        let req = JSON.stringify({
            id: this.state.id
          });
          getCoursesbyUser(req).then(res => {
            if (res.status === 1) {
              this.setState({
                list: res.list
                
              })
            }
          })


    }
 

    render() {
        const { list} = this.state;
        return (
          <React.Fragment>
          <CourseLayout>
                    
            <div class="row ">
           
              <div class="col-xl-12  nopadding">

                    <div class="wallpaper" style={{backgroundImage:`url('../assets/books.jpg')`}}>
                        <div class="courseslogan">
                            <h3>List your course</h3>
                            <div>Help teachers learn and upskill with your courses</div>
                        </div>
                    </div>

                  
                    <div class="listcourses">

                        <ul class="coursesgrid">
                            {list.map((item, index)=>{

                                return <li>
                                            <div class="crname">{item.course_name}</div>
                                            <div class="crdetail">Type:<b>{item.course_type}</b>&nbsp;|&nbsp;Category:<b>{item.course_category}</b>&nbsp;
                                            {item.course_type=='paid' && 
                                              <div>Course Fee:<b>{item.course_fee_currency}{item.course_fee}</b></div>
                                            }
                                            {item.course_status==1 && <div class="green">Approved</div>
                                            }
                                            {item.course_status==0 && <div class="orange">Waiting for approval</div>
                                            }
                                            {item.course_status==2 && <div class="red">Rejected</div>
                                            }
                                            </div>
                                            <div class="editbtn"><span>Views({item.course_views})</span> &nbsp;|&nbsp;<a href={"/courses/editcourse/"+item.id}>Edit</a></div>
                                        </li>

                            })}
                                


                        </ul>

                    </div>

                   

              </div>

            </div>

                </CourseLayout>
            </React.Fragment>
        )
    }
}


export default ListCourse;


// WEBPACK FOOTER //
// ./src/components/bewise/courses/listcourses.jsx